import type { ScreenModule } from "../../../app/screen-module";
import { TenantDashboardPage } from "../pages";

export default {
	id: "tenant-admin.dashboard",
	path: "/admin",
	area: "tenant-admin",
	navGroup: "組織",
	label: "ダッシュボード",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: TenantDashboardPage,
} satisfies ScreenModule;
